<template>
  <div class="ds-control mobile dsf_teas_student_wubie_Detail">
    <div class="content">
      <div class="items">
        <div
          class="item"
          v-for="(item, index) in courses"
          :key="index"
          :class="index == 0 ? 'nomargin' : ''"
        >
          <div class="courseName">{{ item.courseName }}</div>
          <div class="item-content">
            <div class="item-content-common">
              <dsf-icon class="icon-icon-kcfl" />
              <div class="common-right">{{ item.teachForm }}</div>
            </div>
            <div class="item-content-common">
              <dsf-icon class="icon-shijian" />
              <div class="common-right">{{ item.courseTime }}</div>
            </div>
            <div class="item-content-common">
              <dsf-icon class="icon-touxiang" />
              <div class="common-right">
                {{ item.teacherText ? item.teacherText : "暂无" }}
              </div>
            </div>
            <div class="item-content-common">
              <dsf-icon class="icon-location-hollow" />
              <div class="common-right">
                {{ item.placeText ? item.placeText : "暂无" }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="addance-content">
        <div class="title">
          <div class="leftLine"></div>
          <div class="datetitle">考勤情况</div>
        </div>
        <div class="addance">
          <div class="addance-common addance-common-first">
            <div class="time">
              <div class="time-title">考勤状态:</div>
              <div
                class="time-content"
                :class="{
                  'text-green': result.resultValue === '1',
                  'text-blue': '678'.indexOf(result.resultValue) !== -1,
                  'text-red': '1678'.indexOf(result.resultValue) === -1,
                }"
              >
                {{ result.resultText }}
              </div>
            </div>
          </div>
          <div
            class="addance-common"
            v-if="result.signInTime || result.signInPlace"
          >
            <div class="time" v-if="result.signInTime">
              <div class="time-title">签到时间:</div>
              <div class="time-content">
                {{ result.signInTime }}
              </div>
            </div>
            <div class="time lacation" v-if="result.signInPlace">
              <div class="time-title">签到地点:</div>
              <div class="time-content">{{ result.signInPlace }}</div>
            </div>
          </div>
          <div
            class="addance-common"
            v-if="result.signOutTime || result.signOutPlace"
          >
            <div class="time" v-if="result.signOutTime">
              <div class="time-title">签退时间:</div>
              <div class="time-content">
                {{ result.signOutTime }}
              </div>
            </div>
            <div class="time lacation" v-if="result.signOutPlace">
              <div class="time-title">签退地点:</div>
              <div class="time-content">{{ result.signOutPlace }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-scan" @click="clickAddance" v-if="result.attend" >
      <div class="btn">开始考勤</div>
    </div>
  </div>
</template>

<script>
const testData = {
  courses: [
    {
      id: "522ce46b3eb84051b5b05b8172ef75ee",
      courseName: "习近平新时代中国特色社会主义思想理论研修班必修课程",
      courseTime: "2021-10-08 08:30 -2021-10-08 11:30",
      teacherText: "科比",
      placeText: "汇融广场",
      teachForm: "专题辅导",
    },
    {
      id: "522ce46b3eb84051b5b05b8172ef75ee",
      courseName: "习近平新时代中国特色社会主义思想理论研修班必修课程",
      courseTime: "2021-10-08 08:30 -2021-10-08 11:30",
      teacherText: "科比",
      placeText: "汇融广场",
      teachForm: "专题辅导",
    },
    {
      id: "522ce46b3eb84051b5b05b8172ef75ee",
      courseName: "习近平新时代中国特色社会主义思想理论研修班必修课程",
      courseTime: "2021-10-08 08:30 -2021-10-08 11:30",
      teacherText: "科比",
      placeText: "汇融广场",
      teachForm: "专题辅导",
    },
  ],
  result: {
    attendTypeText: null,
    attendTypeValue: null,
    latitude: null,
    longitude: null,
    radius: null,
    resultText: "未签",
    signInPlace: null,
    signInTime: null,
    signOutPlace: null,
    signOutTime: null,
  },
};
export default dsf.component({
  name: "DsfMobileTeasStudentWubieDetail",
  mixins: [$mixins.control],
  ctrlCaption: "午别课程考勤详情",
  design: {
    isMask: false,
  },
  props: {
    sourcesUrl: {
      type: String,
      default: "/teas/mobile/attendance/findCourseOrNoonAttendTypeInfo",
    },
    scanCodeUrl: {
      type: String,
      default: "/teas/mobile/attendance/scanCodeAttend",
    },
    locationUrl: {
      type: String,
      default: "/teas/mobile/attendance/positioningAttendance",
    },
  },
  data() {
    return {
      courses: [],
      result: {},
      type: "", // 1：课程，2：午别
      relId: "",
    };
  },
  created() {
    this.type = this.$route.query.type;
    this.relId = this.$route.query.relId;
    if (this.isDesign) {
      this.courses = testData.courses;
      this.result = testData.result;
    } else {
      this.getInfor();
    }
    if (dsf.client.weixin() && window.$wx) {
      window.$wx.init();
    }
  },
  methods: {
    // 判断两个点之间的距离
    getGreatCircleDistance(lat1, lng1, lat2, lng2) {
      var EARTH_RADIUS = 6378137.0;
      var PI = Math.PI;

      function getRad(d) {
        return (d * PI) / 180.0;
      }
      var radLat1 = getRad(lat1);
      var radLat2 = getRad(lat2);

      var a = radLat1 - radLat2;
      var b = getRad(lng1) - getRad(lng2);

      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000.0;

      return s;
    },
    clickAddance() {
      if (this.$listeners["startAddance"]) {
        this.$dispatch("startAddance", item);
      }else {
        this.qrScan();
      }
    },
    // 定位的请求
    requestlocation(place) {
      let param = {
        place: place,
        attendMode: this.type,
      };
      const loading = dsf.layer.loading();
      this.$http
        .post(this.locationUrl, param)
        .done((res) => {
          if (res.success && res.state == 20000) {
            dsf.layer.message(res.message, true);
            this.getInfor();
            this.$dispatch("completed");
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
    // 扫一扫
    qrScan() {
      if (this.result.attendTypeValue == "1") {
        var outloading = dsf.layer.loading("定位中");
        // 定位考勤
        dsf.driver.location
          .getBD()
          .then((response) => {
            dsf.layer.closeLoading(outloading);
            let place = response.address;
            if (!place) {
              place = '';
            }
            let lat = response.lat;
            let lng = response.lng;
            if (!lat || !lng) {
              dsf.layer.message("定位失败", false);
              return;
            }
            let distance = this.getGreatCircleDistance(
              lat,
              lng,
              this.result.latitude,
              this.result.longitude
            );
            if (parseInt(distance) > parseInt(this.result.radius)) {
              dsf.layer.message("您当前不在考勤范围内", false);
              return;
            }
            if (dsf.client.wechat()) {
              this.$http
              .get('teas/attendance/locationInverseCoding', {
                'longitude': lng,
                'latitude': lat
              })
              .done((res) => {
                if (res.success && res.state == 20000) {
                    this.requestlocation(res.data)
                } else {
                  dsf.layer.message(res.message, false);
                }
              })
              .error((err) => {
                dsf.layer.message(err.message || "出错了，请重试", false);
              })
              .always(() => {
              });
            } else {
              this.requestlocation(place)
            }
          })
          .catch((res) => {
            dsf.layer.closeLoading(outloading);
            dsf.layer.alert(JSON.stringify(res));
          });
          // 这种处理安卓那边无法返回定位强行关闭loading
          setTimeout(() => {
            dsf.layer.closeLoading(outloading);
          }, 6000)
      } else {
        dsf.driver.camera
          .scan()
          .then((response) => {
            if (!response) return;
            if (response == 'error') return;
            if (response.indexOf('relId') == -1) {
              dsf.layer.message('请扫描正确的考勤二维码', false);
              return;
            }
            const loading = dsf.layer.loading();
            this.$http
              .post(this.scanCodeUrl, response, {
                headers: {
                  "Content-Type": "application/json;charset=UTF-8",
                },
              })
              .done((res) => {
                if (res.success && res.state == 20000) {
                  dsf.layer.message(res.message, true);
                  this.getInfor();
                  this.$dispatch("completed");
                } else {
                  dsf.layer.message(res.message, false);
                }
              })
              .error((err) => {
                dsf.layer.message(err.message || "出错了，请重试", false);
              })
              .always(() => {
                dsf.layer.closeLoading(loading);
              });
          })
          .catch((msg) => {
            dsf.layer.alert(JSON.stringify(msg));
          });
      }
    },
    // 获取数据
    getInfor() {
      var loading = dsf.layer.loading();
      this.$http
        .get(this.sourcesUrl, {
          type: this.type,
          relId: this.relId,
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            this.courses = res.data.courses;
            this.result = res.data.result;
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  },
});
</script>
